// TODO: Need to add translation
// Options for establishment type dropdown
export const ESTABLISHMENT_OPTIONS = [
  "Proprietorship",
  "Partnership",
  "Company",
];
